// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fill-color[data-v-6c8d4992] {\n  fill: var(--green-color);\n}\n.stroke-color[data-v-6c8d4992] {\n  stroke: var(--green-color);\n}", ""]);
// Exports
module.exports = exports;
